import { GcpApi } from '@/api/gcp';
import { useQuery } from '@tanstack/react-query';
import { gcpKeys } from './gcp.keys';

export function useActiveConnection(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true;
  return useQuery({
    queryKey: gcpKeys.activeConnection(),
    queryFn: GcpApi.getActiveConnection,
    enabled,
  });
}

export function useGcpProjects() {
  return useQuery({
    queryKey: gcpKeys.projects(),
    queryFn: GcpApi.getProjects,
  });
}

export function useFirestoreDatabases(projectId: string) {
  return useQuery({
    queryKey: gcpKeys.databases(projectId),
    queryFn: () => GcpApi.getFirestoreDatabases(projectId),
    enabled: !!projectId,
  });
}
